export const HELP_ALERT =
  'To request assistance, please contact us at the following email address';
export const SUPPORT_EMAIL = 'studiosupport@klydoclock.com';
export const DELETE_KLYDO_ALERT = 'Are you sure you want to delete this Klydo?';
export const DELETE_KLYDO_SECCESSFULLY_ALERT = 'Klydo deleted successfully';
export const EDIT_PROFILE_ALERT =
  'Profile Saved. (Updates may take up to 24 hours)';
export const UPDATE_PROFILE_FAILED_ALERT = 'Profile update failed';
export const UPDATE_KLYDO_FAILED_ALERT = 'Klydo update failed';
export const UPLOAD_FILE_FAILED_ALERT = 'File upload failed';
export const INVAILED_LOOP_FILE_TYPE_ALERT =
  'Invalid file type. Only MP4 and GIF files are allowed.';
export const MAX_FILE_SIZE_ALERT =
  'File size exceeds the limit. Max size is 70MB.';
export const INCOMPLETE_PROFILE_ALERT = 'Please complete your profile';
export const INCOMPLETE_PROFILE_REASON_ALERT =
  'Profile is missing some required fields';
export const INCOMPLETE_KLYDO_DATA_ALERT = 'Klydo is incomplete';
export const INCOMPLETE_KLYDO_DATA_REASON_ALERT =
  'Please complete all required fields (name, file, and theme colors) before submitting';
/**
 * The reschedule path. It moves the date on an ALREADY-APPROVED request, so nothing
 * is submitted and nothing is reviewed — it used to reuse the submit message, which
 * was simply untrue.
 */
export const PUBLICATION_DATE_UPDATED_SUCCESS = 'Publication date updated';
export const SUBMIT_FOR_REVIEW_ALERT = `Are you ready to submit your klydo?

                                        Please note that once a klydo is approved it cannot be edited.`;
export const SUBMIT_COLLECTION_FOR_REVIEW_ALERT = `Are you sure you want to publish your collection?

Please note that once a collection is approved and published this action cannot be undone.`;
export const EMOJIS_NOT_ALLOWED_ALERT = 'Emojis are not allowed';
export const COLLECTION_NAME_TAKEN_ALERT =
  'A collection with this name already exists. Please choose a different name before publishing.';
export const PREVIEW_GENERATION_FAILED_ALERT =
  'Failed to generate preview. Please try again.';
export const DELETE_COLLECTION_ALERT =
  'Are you sure you want to delete this collection?';
export const DELETE_COLLECTION_SUCCESSFULLY_ALERT =
  'Collection deleted successfully';
export const MAX_LABELS_REACHED_ALERT = 'Maximum of 3 tags allowed';
export const CANCEL_REVIEW_WARNING_MESSAGE =
  'Are you sure you want to cancel the review? This will return the Klydo to draft status.';
/**
 * The sealed variant of the message above. A klydo sealed by its collection
 * never returns to draft — withdrawing only takes back the publication request
 * — so promising "draft status" there would be false.
 */
export const WITHDRAW_REQUEST_WARNING_MESSAGE =
  'Are you sure you want to withdraw the publication request? This Klydo was finalized with its collection, so it will stay locked for editing.';
export const PAYMENT_PENDING_ALERT =
  'Your last payment is pending. Please check the Payment page for details.';
export const EDIT_ARTIST_IDENTITY_ALERT = 'Artist identity saved successfully';
/**
 * Publish-button tooltip when the collection mixes sound profiles. Shown INSTEAD
 * of the missing-fields list — sound consistency is checked first.
 */
export const INCONSISTENT_COLLECTION_SOUND_TOOLTIP = `Make your Klydos consistent

To submit this collection to the Marketplace, all Klydos must have consistent audio settings.
Please make sure all Klydos either include or exclude sound and Chimes & Strikes.`;
